
<div class="main-content">
    <div class="container-fluid">
        <div class="card sq-card">
            <div class="card-header card-header-squirrel">
                <h4>{{pageTitle}}</h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <mat-tab-group dynamicHeight preserveContent animationDuration="0">
                            <mat-tab label="Mandant Info">
                                <ng-template matTabContent>
                                    <tenant-info-mode [tenant]="tenantDto"></tenant-info-mode>
                                </ng-template>                                
                            </mat-tab> 
                            <mat-tab label="Benutzer">
                                <ng-template matTabContent>
                                    <tenant-users [tenant]="tenantDto"></tenant-users>
                                </ng-template>                                
                            </mat-tab> 
                            <mat-tab label="Projekte">
                                <ng-template matTabContent>
                                    <tenant-projects [tenant]="tenantDto"></tenant-projects>
                                </ng-template>                                
                            </mat-tab>                                                                                 
                            <mat-tab label="Mandantengruppenrollen">
                                <ng-template matTabContent>
                                    <tenant-grouproles [tenant]="tenantDto"></tenant-grouproles>
                                </ng-template>                                
                            </mat-tab>                                                                                 
                          </mat-tab-group>
                    </div>
                </div>               
            </div>
        </div>
    </div>
</div>